export default __webpack_public_path__ + "static/media/0000.1a9d5fe8.svg";